import { useState } from 'react'

import emailjs from '@emailjs/browser'
import confetti from 'canvas-confetti'
import { client } from '../../client'
import { images } from '../../constants'
import { AppWrap, MotionWrap } from '../../wrapper'
import './Footer.scss'

const Footer = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    message: '',
  })
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState({})

  const { username, email, message } = formData

  const validate = () => {
    let tempErrors = {}
    if (!username.trim()) tempErrors.username = 'Name is required'
    if (!email.trim()) {
      tempErrors.email = 'Email is required'
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      tempErrors.email = 'Email is invalid'
    }
    if (!message.trim()) tempErrors.message = 'Message cannot be empty'

    setErrors(tempErrors)
    // Returns true if the errors object is empty
    return Object.keys(tempErrors).length === 0
  }

  const handleChangeInput = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })

    // Clear error for this field as the user types
    if (errors[name]) {
      setErrors({ ...errors, [name]: '' })
    }
  }

  const handleSubmit = () => {
    if (validate()) {
      setLoading(true)

      // This object matches the {{placeholders}} in your EmailJS template
      const templateParams = {
        from_name: formData.username,
        user_email: formData.email,
        message: formData.message,
      }

      const contact = {
        _type: 'contact',
        name: username,
        email: email,
        message: message,
      }

      client
        .create(contact)
        .then(() => {
          // 2. Send Notification to YOU
          return emailjs.send(
            process.env.REACT_APP_EMAILJS_SERVICE_ID,
            process.env.REACT_APP_EMAILJS_CONTACT_TEMPLATE_ID,
            templateParams,
            process.env.REACT_APP_EMAILJS_PUBLIC_KEY
          )
        })
        .then(() => {
          // 3. Send Auto-Reply to USER
          return emailjs.send(
            process.env.REACT_APP_EMAILJS_SERVICE_ID,
            process.env.REACT_APP_EMAILJS_AUTO_REPLY_TEMPLATE_ID,
            templateParams,
            process.env.REACT_APP_EMAILJS_PUBLIC_KEY
          )
        })
        // 4. Success! Trigger Flash Paper UI
        .then(() => {
          setLoading(false)
          setIsFormSubmitted(true)
          confetti({
            particleCount: 150,
            spread: 70,
            origin: { y: 0.6 },
            colors: ['#313bac', '#ffffff', '#edf2f8'],
          })
        })
        .catch((err) => {
          setLoading(false)
          console.error(err)
        })
    }
  }

  return (
    <>
      <h2 className='head-text'>
        Take a coffee <span>&</span> chat with me
      </h2>

      <div className='app__footer-cards'>
        <div className='app__footer-card '>
          <img src={images.email} alt='email' />
          <a href='mailto:lazycoderlee@gmail.com' className='p-text'>
            lazycoderlee@gmail.com
          </a>
        </div>
        <div className='app__footer-card'>
          <img src={images.linkedin} alt='linkedin' />
          <a
            href='https://www.linkedin.com/in/khaleel-basha-dudekula/'
            target='_blank'
            rel='noreferrer'
            className='p-text'
          >
            Connect on LinkedIn
          </a>
        </div>
      </div>

      {!isFormSubmitted ? (
        <div className='app__footer-form app__flex'>
          <div className='app__flex'>
            <input
              className='p-text'
              type='text'
              placeholder='Your Name'
              name='username'
              value={username}
              onChange={handleChangeInput}
            />
          </div>
          {errors.username && <p className='error-text'>{errors.username}</p>}

          <div className='app__flex'>
            <input
              className='p-text'
              type='email'
              placeholder='Your Email'
              name='email'
              value={email}
              onChange={handleChangeInput}
            />
          </div>
          {errors.email && <p className='error-text'>{errors.email}</p>}

          <div>
            <textarea
              className='p-text'
              placeholder='Your Message'
              value={message}
              name='message'
              onChange={handleChangeInput}
            />
          </div>
          {errors.message && <p className='error-text'>{errors.message}</p>}

          <button type='button' className='p-text' onClick={handleSubmit}>
            {!loading ? 'Send Message' : 'Sending...'}
          </button>
        </div>
      ) : (
        <div>
          <h3 className='head-text'>Thank you for getting in touch!</h3>
        </div>
      )}
    </>
  )
}

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__whitebg'
)
